import { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { map, intersection, findIndex } from "lodash";
import Grid from "@mui/material/Grid";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { assignmentSliceActions } from "../../Store/Slices/AssignSlice";
import {
  getTaskList,
  getAssignmentInfo,
  getTaskListFromUid,
  getLearnersFromUid,
  getAssignFromTitle,
} from "./Services";
import WwDatePicker from "../../Components/Modal/WwDatePicker";
import {
  getFormatedDateTime,
  convertMinToSecond,
  convertSecondToMin,
} from "../../Js/TimeAndDate";
import { getClassNames } from "../../Js/Common";
import { durationCalculate } from "../../Js/Common";
import { validator } from "../../Js/Validator";
import ProductSelection from "./ProductSelection";
import Confirmation from "../../Components/Modal/Confirmation";
import ClassList from "./ClassList";
import Preferences from "./Preferences";
import TaskSelection from "./TaskSelection";
import LearnersList from "./LearnersList";
import { createAssignment, updateAssignment } from "./Services";
import { userLogs } from "../../Js/Common";

const pathToParentMenu = ["root"];
let todayTimeStamp = new Date();
// todayTimeStamp.setHours(0);
// todayTimeStamp.setMinutes(0);
// todayTimeStamp.setSeconds(0);
todayTimeStamp = todayTimeStamp.getTime();
let today = Date();
let commencesdt = new Date();

const AssignCreateEdit = (props) => {
  const classesName = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigation = useNavigate();
  const { type, id } = useParams();

  // State
  const [selectedProduct, setSelectedProduct] = useState("");
  const [valid, setValid] = useState(false);
  const [assignmentNameErrorMessage, setAssignmentNameErrorMessage] =
    useState(null);
  const [endMinDate, setEndMinDate] = useState(Date.now());
  const [alertFlag, setAlertFlag] = useState(false);
  const [alertErrorStartDate, setAlertErrorStartDate] = useState(null);
  const [alertErrorEndDate, setAlertErrorEndDate] = useState(null);
  const [currentMessage, setCurrentMessage] = useState(null);
  const [assignmentData, setAssignmentData] = useState(null);
  const [taskType, setTaskType] = useState(null);
  const [oldLearners, setOldLearners] = useState([]);
  const [errorModal, setErrorModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const {
    selectedTasks,
    duration,
    assignmentName,
    description,
    commences,
    expiries,
    mode,
    assignmentId,
    eexam,
    eexamTime,
    durationStartTimeStamp,
    selectedLearners,
    selectedClasses,
    defaults,
  } = useSelector((state) => state.assignment);
  const { siteConfig } = useSelector((state) => state.defs);

  // React logic hooks

  useEffect(() => {
    if (location.pathname.includes("Create")) {
      dispatch(assignmentSliceActions.setMode("create"));
      dispatch(assignmentSliceActions.setAssignmentId(null));
      setValid(false);
    }
    if (location.pathname.includes("Edit")) {
      dispatch(assignmentSliceActions.setMode("edit"));
      setValid(true);
    }

    let autoAssignEditObj = sessionStorage.getItem("autoAssignEditObj");
    if (autoAssignEditObj) {
      autoAssignEditObj = JSON.parse(autoAssignEditObj);
      setAssignmentData(autoAssignEditObj);
      setTasks(autoAssignEditObj.tasks.tasks);
      setLearners(autoAssignEditObj.learners.learners);
      setValid(true);
    }

    dispatch(assignmentSliceActions.setDurationFlag(true));
    dispatch(assignmentSliceActions.startDuration());
    setTaskType(type);
    if (type) {
      if (type.toUpperCase() == "MEDIA") {
        dispatch(assignmentSliceActions.setDefaultsAttempts("1"));
      }
      if (type.toUpperCase() == "LIBRARY") {
        dispatch(assignmentSliceActions.setDefaultsAttempts("1"));
      }
    }

    const innerFunction = async () => {
      //setClasses(await getClassNames(userInfo.site_uuid));
      // let learnersData = await getClassLearners(
      //   map(selectedClasses, "id"),
      //   userInfo.site_uuid
      // );
      // setLearners(learnersData.data);
    };
    innerFunction();

    return () => {
      dispatch(assignmentSliceActions.resetState());
      sessionStorage.removeItem("autoAssignEditObj");
    };
  }, []);

  useEffect(() => {
    if (mode == "edit" && assignmentId == null) {
      fetchAssignmentInfo();
    }
    if (mode == "edit") {
      dispatch(assignmentSliceActions.startDuration());
    }
  }, [mode]);

  useEffect(() => {
    if (mode == "edit" && oldLearners.length == 0) {
      setOldLearners(selectedLearners);
    }
  }, [mode, selectedLearners]);

  useEffect(() => {
    if (assignmentData) {
      dispatch(assignmentSliceActions.setAssignmentName(assignmentData.title));
      dispatch(
        assignmentSliceActions.setDescription(assignmentData.description)
      );
      dispatch(
        assignmentSliceActions.setCommences(
          getFormatedDateTime(assignmentData.commences)
        )
      );
      commencesdt = new Date(assignmentData.commences);
      dispatch(
        assignmentSliceActions.setExpiries(
          getFormatedDateTime(assignmentData.expiries)
        )
      );
      if (mode == "edit") {
        dispatch(assignmentSliceActions.setAssignmentId(assignmentData.uid));
      }
      dispatch(assignmentSliceActions.setEexam(assignmentData.is_exam));
      if (assignmentData.is_exam) {
        dispatch(
          assignmentSliceActions.setEexamTime(
            +assignmentData.estimated_time / 60
          )
        );
      }
      dispatch(
        assignmentSliceActions.setDefaultsAttempts(
          assignmentData.defaults.defaults.noofattempts
        )
      );
      dispatch(
        assignmentSliceActions.setDefaultsShowAnswer(
          assignmentData.defaults.defaults.showanswerfunctionality
        )
      );
      dispatch(
        assignmentSliceActions.setDefaultsShuffleOptions(
          assignmentData.defaults.defaults.shufflefunctionality
        )
      );
    }
  }, [assignmentData]);

  // Fetch Assignment Information
  const fetchAssignmentInfo = async () => {
    let assignmentInfoData = await getAssignmentInfo(id, userInfo.site_uuid);
    setAssignmentData(assignmentInfoData.data[0]);
    setTasks(assignmentInfoData.data[0].tasks.tasks);
    setLearners(assignmentInfoData.data[0].learners.learners);
  };

  // Get all selected tasks
  const setTasks = async (tasksArg) => {
    let tasks = await getTaskListFromUid(tasksArg, userInfo.site_uuid, mode);
    console.log("!!", tasks);
    if (tasks["data"][0]["tasktype"].toUpperCase() == "ASSETS") {
      dispatch(
        assignmentSliceActions.setProduct(tasks["data"][0]["product_uid"])
      );
      setTaskType("assets");
    }
    if (tasks["data"][0]["tasktype"].toUpperCase() == "LIBRARY") {
      dispatch(
        assignmentSliceActions.setProduct(tasks["data"][0]["product_uid"])
      );
      setTaskType("library");
    }
    if (tasks["data"][0]["tasktype"].toUpperCase() == "MEDIA") {
      setTaskType("media");
      dispatch(assignmentSliceActions.setDefaultsAttempts("1"));
    }
    dispatch(
      assignmentSliceActions.setAllSelectedTasks(
        prepareTaskArray(tasks["data"])
      )
    );
  };

  // prepareTask data to set in redux
  const prepareTaskArray = (tasksData) => {
    return tasksData.map((val) => {
      return {
        id: val.uid,
        name: val.title,
        estimated_time: val.estimated_time,
        assets: val.data1.exersices,
      };
    });
  };

  // Get all selected tasks
  const setLearners = async (learnersArg) => {
    let learners = await getLearnersFromUid(learnersArg, userInfo.site_uuid);
    let learnerObjects = prepareLearnerArray(learners["data"]);
    dispatch(assignmentSliceActions.setAllSelectedLearners(learnerObjects));
    setClasses(learnerObjects);
  };

  // prepareTask data to set in redux
  const prepareLearnerArray = (learnersData) => {
    return learnersData.map((val) => {
      return {
        id: val.uid,
        name: val.name.firstname + " " + val.name.lastname,
        belongs_to: val.belongs_to,
      };
    });
  };

  // Set class list
  const setClasses = async (learners) => {
    let allClasses = await getClassNames(userInfo.site_uuid);
    let selectedClasses = allClasses.filter((val) => {
      if (findIndex(learners, { belongs_to: val.id }) != -1) {
        return {
          id: val.id,
          value: val.value,
        };
      }
    });
    dispatch(assignmentSliceActions.setAllSelectedClass(selectedClasses));
  };

  const validateInfo = () => {
    console.log("commen", commences);
    if (alertErrorStartDate) {
      setCurrentMessage(
        "Start date and time must be current date/time or later."
      );
      setAlertFlag(true);
      return false;
    }
    if (alertErrorEndDate) {
      setCurrentMessage("End time must be later than current time.");
      setAlertFlag(true);
      return false;
    }
    if (selectedTasks.length == 0) {
      setCurrentMessage("You must select at least 1 task");
      setAlertFlag(true);
      return false;
    }
    if (!expiries) {
      setCurrentMessage("Please select End Date");
      setAlertFlag(true);
      return false;
    }
    if (selectedClasses && selectedClasses.length == 0) {
      setCurrentMessage("Select at least 1 class");
      setAlertFlag(true);
      return false;
    }
    if (selectedLearners && selectedLearners.length == 0) {
      setCurrentMessage("Select at least 1 learner");
      setAlertFlag(true);
      return false;
    }
    if (+defaults.noofattempts < 1 || +defaults.noofattempts > 9) {
      setCurrentMessage("No of attempts should be between 1 and 9");
      setAlertFlag(true);
      return false;
    }
    if (+eexamTime < 1 || +eexamTime > 60) {
      setCurrentMessage("e-exam is of minimum 1 min and maximum 60 mins");
      setAlertFlag(true);
      return false;
    }

    assignmentNameBlurValidate();
    if (valid) {
      return true;
    } else {
      return false;
    }
  };

  // Validate taskname on blur
  const assignmentNameBlurValidate = () => {
    let validate = validator({
      required: true,
      value: assignmentName ? assignmentName.trim() : assignmentName,
    });
    if (!validate["validate"]) {
      setAssignmentNameErrorMessage(validate["message"]);
      setValid(false);
    } else {
      setAssignmentNameErrorMessage(null);
      setValid(true);
    }
  };

  // Date change
  const DateChange = (date, valid, err, field) => {
    console.log("field", date);
    if (valid) {
      if (field == "startdate") {
        dispatch(assignmentSliceActions.setCommences(date));
        let endMinTime = new Date(date);
        // endMinTime.setHours(0);
        // endMinTime.setMinutes(0);
        // endMinTime.setSeconds(0);
        setEndMinDate(endMinTime.getTime());
        setAlertErrorStartDate(null);
      }
      if (field == "enddate") {
        dispatch(assignmentSliceActions.setExpiries(date));
        setAlertErrorEndDate(null);
      }
    } else {
      setTimeout(() => {
        setAlertFlag(true);
        if (field == "startdate") {
          setAlertErrorStartDate(err);
          setCurrentMessage(err);
        }
        if (field == "enddate") {
          setAlertErrorEndDate(err);
          setCurrentMessage(err);
        }
      }, 500);
    }
  };

  // Check old learners not removed
  const checkOldLearners = () => {
    console.log("!!!!!FFF1");
    let oldLearnerArr = map(oldLearners, "id");
    let selectedLearnersArr = map(selectedLearners, "id");
    let intersectionResult = intersection(selectedLearnersArr, oldLearnerArr);
    console.log("!!!!!FFF", oldLearnerArr);
    console.log("!!!!!FFF", selectedLearnersArr);
    console.log("!!!!!FFF", intersectionResult);
    if (intersectionResult.length == oldLearnerArr.length) {
      return true;
    } else {
      return false;
    }
  };

  // Save assignment
  const saveAssignment = async () => {
    console.log("commences", commences);
    console.log("commences", new Date(commences));
    console.log("expiries", expiries);
    //return false;

    let nameExist = await getAssignFromTitle(
      assignmentName.trim(),
      userInfo.site_uuid
    );
    // Object for assignment save
    let validation = validateInfo();
    if (
      validation &&
      (nameExist.data.length == 0 || nameExist.data[0]["uid"] == assignmentId)
    ) {
      let assignmentData = {
        title: assignmentName,
        created_by: userInfo.uid,
        tasks: { tasks: map(selectedTasks, "id") },
        learners: { learners: map(selectedLearners, "id") },
        commences: commences,
        expiries: expiries,
        estimated_time: selectedTasks.reduce((total, val) => {
          return total + Number(val.estimated_time);
        }, 0),
        description: description,
        defaults: defaults,
        site_uuid: userInfo.site_uuid,
        is_exam: eexam,
      };

      // change defaults if assignment is E-exam
      if (eexam) {
        assignmentData["estimated_time"] = eexamTime * 60;
        let defaultData = {
          defaults: {
            ...assignmentData["defaults"]["defaults"],
            showanswerfunctionality: false,
            noofattempts: "1",
          },
        };
        assignmentData["defaults"] = defaultData;
      }

      // Log object
      let logObj = {
        actor: userInfo.uid,
        verb: "assignment",
        outcome: {
          duration: durationCalculate(duration, durationStartTimeStamp),
        },
        site_uuid: userInfo.site_uuid,
      };

      let response;
      if (mode == "create") {
        response = await createAssignment(assignmentData);
        logObj["outcome"]["action"] = "create";
        logObj["target"] = response.data.uid;
        logObj["outcome"]["value"] = {
          learners: response.data.learners.learners,
          tasks: response.data.tasks.tasks,
        };
      }
      if (mode == "edit") {
        if (!checkOldLearners()) {
          setErrorModal(true);
          return false;
        }
        response = await updateAssignment(
          assignmentData,
          assignmentId,
          userInfo.site_uuid
        );
        logObj["outcome"]["action"] = "edit";
        logObj["target"] = assignmentId;
        logObj["outcome"]["value"] = {
          learners: map(selectedLearners, "id"),
          tasks: map(selectedTasks, "id"),
        };
      }

      // On create assignment success drop log for it
      if (response.status == 200) {
        setConfirmModal(true);
        let logResponse = await userLogs(logObj);
      }
    } else {
      console.log("nameExist", nameExist);
      if (
        nameExist.data.length > 0 &&
        nameExist.data[0]["uid"] != assignmentId
      ) {
        setCurrentMessage("Assignment name should be unique.");
        setAlertFlag(true);
      }
    }
  };

  return (
    <Grid container>
      {/* <GenerateMenu menuJson={menuJson} goToSubmenu={goToSubmenu}></GenerateMenu>
            {pathToParentMenu.length > 1 &&
                <Button variant="contained" color='secondary' onClick={backMenu}>Back</Button>
            } */}

      <Grid item xs={12}>
        <Grid
          container
          sx={{
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <Grid item xs={12} >
            <Box
              sx={{
                border: 1,
                borderColor: "#EAECEE",
                borderRadius: 5,
                background: "linear-gradient(135deg, rgba(180,227,145,1) 0%,rgba(97,196,25,1) 50%,rgba(180,227,145,1) 100%)",
                py: 2,
                mx: 6,
                mt: 1,
                height: "62vh",
              }}
            >
              <Grid
                container
                sx={{
                  flexDirection: "row",
                  flexFlow: "wrap",
                  justifyContent: "flex-start",
                  px: 2,
                  gap: 6,
                  mt: 1,
                }}
              >
                <Grid item xs={5}>
                  <Grid container>
                    <Grid item xs={12}>
                      <ProductSelection></ProductSelection>
                    </Grid>
                    <Grid item xs={12}>
                      <TaskSelection type={taskType}></TaskSelection>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        color="#5f5600ff"
                        sx={{
                          ml: 4,
                          mt: 2,
                          letterSpacing: 1,
                          fontSize: "1.2rem",
                          fontWeight: "500",
                          "@media (min-width: 1636px)": {
                            fontSize: "1.4rem",
                          },
                        }}
                      >
                        Assignment Name:
                      </Typography>
                      <FormControl
                        fullWidth
                        sx={{
                          mx: 1,
                          mb: 1,
                          borderRadius: "50px",
                          border: 1,
                          backgroundColor: "#F5F5F5",
                          borderColor: "#A9A9A9",
                          paddingBottom: "2px",
                        }}
                      >
                        <TextField
                          InputProps={{
                            disableUnderline: true,
                            inputProps: {
                              sx: {
                                fontSize: "0.8rem",
                                "@media (min-width: 1636px)": {
                                  fontSize: "1.2rem",
                                },
                              },
                            },
                          }}
                          variant="standard"
                          id="outlined-search"
                          type="search"
                          placeholder="Assignment Name"
                          size="small"
                          sx={{
                            px: 2,
                            paddingTop: "7px",
                            color: "primary.main",
                          }}
                          error={assignmentNameErrorMessage}
                          helperText={assignmentNameErrorMessage}
                          onBlur={() => assignmentNameBlurValidate()}
                          onInput={(event) => {
                            dispatch(
                              assignmentSliceActions.setAssignmentName(
                                event.target.value
                              )
                            );
                          }}
                          value={assignmentName}
                        />
                      </FormControl>
                    </Grid>
                    {siteConfig.customer?.addOnInfo?.isSelfLearning && (
                      <Grid item xs={12}>
                        <Typography
                          color="#5f5600ff"
                          sx={{
                            ml: 4,
                            mt: 2,
                            letterSpacing: 1,
                            fontSize: "1.2rem",
                            fontWeight: "500",
                            "@media (min-width: 1636px)": {
                              fontSize: "1.4rem",
                            },
                          }}
                        >
                          Description:
                        </Typography>
                        <FormControl
                          fullWidth
                          sx={{
                            mx: 1,
                            mb: 1,
                            borderRadius: "50px",
                            border: 1,
                            backgroundColor: "#F5F5F5",
                            borderColor: "#A9A9A9",
                            paddingBottom: "2px",
                          }}
                        >
                          <TextField
                            InputProps={{
                              disableUnderline: true,
                              inputProps: {
                                sx: {
                                  fontSize: "1.1rem",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "1.2rem",
                                  },
                                },
                              },
                            }}
                            variant="standard"
                            id="outlined-search"
                            type="search"
                            placeholder="Assignment Description"
                            size="small"
                            sx={{
                              px: 2,
                              paddingTop: "7px",
                              color: "primary.main",
                            }}
                            onInput={(event) => {
                              dispatch(
                                assignmentSliceActions.setDescription(
                                  event.target.value
                                )
                              );
                            }}
                            value={description}
                          />
                        </FormControl>
                      </Grid>
                    )}
                    <Grid item xs={12}>
                      <Typography
                        color="#5f5600ff"
                        sx={{
                          ml: 4,
                          mt: 2,
                          letterSpacing: 1,
                          fontSize: "1.2rem",
                          fontWeight: "500",
                          "@media (min-width: 1636px)": {
                            fontSize: "1.4rem",
                          },
                        }}
                      >
                        Date:
                      </Typography>
                      <Grid container sx={{ gap: 2 }}>
                        <Grid item xs={5}>
                          <WwDatePicker
                            placeholder="Start date"
                            dateChange={({ date, valid, errorMessage }) =>
                              DateChange(date, valid, errorMessage, "startdate")
                            }
                            minDate={todayTimeStamp}
                            defaultDate={
                              assignmentData && assignmentData.commences
                                ? assignmentData.commences
                                : today
                            }
                            disabled={
                              mode == "edit" &&
                              commencesdt.getTime() < todayTimeStamp
                            }
                            withTime={true}
                          ></WwDatePicker>
                        </Grid>
                        <Grid item xs={5}>
                          <WwDatePicker
                            placeholder="End date"
                            dateChange={({ date, valid, errorMessage }) => {
                              console.log("#####", date);
                              DateChange(date, valid, errorMessage, "enddate");
                            }}
                            minDate={endMinDate}
                            defaultDate={
                              assignmentData && assignmentData.expiries
                                ? assignmentData.expiries
                                : null
                            }
                            withTime={true}
                            toTime={true}
                          ></WwDatePicker>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        size="small"
                        sx={{
                          px: 5,
                          ml: 3,
                          mt: 2,
                          borderRadius: 15,
                          backgroundColor: "#5f5600ff",
                          color: "#FFFFFF",
                          height: "2rem",
                          textTransform: "inherit",
                         
                          fontWeight: "500",
                          "@media (min-width: 1636px)": {
                            fontSize: "1.4rem",
                            height: "3rem",
                          },
                        }}
                        onClick={() => {
                          saveAssignment();
                        }}
                      >
                        Save
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    color="#5f5600ff"
                    sx={{
                      ml: 4,
                      letterSpacing: 1,
                      fontSize: "1.2rem",
                      fontWeight: "500",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                      },
                    }}
                  >
                    Select Learners:{" "}
                  </Typography>
                  <Box
                    sx={{
                      border: 1,
                      borderColor: "#EAECEE",
                      borderRadius: 5,
                      mt: 1,
                    }}
                  >
                    <ClassList></ClassList>
                    <Box
                      className={classesName.scrollBar}
                      sx={{ height: "32vh", overflow: "auto", mr: 2, mb: 2 }}
                    >
                      <LearnersList></LearnersList>
                    </Box>
                  </Box>
                  {(type == "assets" || taskType == "assets") &&
                    mode == "create" && (
                      <Box
                        sx={{
                          border: 1,
                          borderColor: "#EAECEE",
                          borderRadius: 5,
                          mt: 2,
                        }}
                      >
                        {" "}
                        <Preferences
                          type={type}
                          edittype={taskType}
                        ></Preferences>
                      </Box>
                    )}
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12} sx={{ mt: 2, mx: 6 }}>
            <Box
              sx={{ backgroundColor: "#F5F7FF", padding: 2, borderRadius: 5 }}
            >
              <Typography
                color="#5f5600ff"
                sx={{
                  fontWeight: "bold",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.4rem",
                  },
                }}
              >
                Assignment Summary:
              </Typography>
              <Typography
                color="#5f5600ff"
                sx={{
                  fontSize: "1rem",
                  mt: 1,
                  letterSpacing: 1,
                  "@media (min-width: 1636px)": {
                    fontSize: "1.4rem",
                  },
                }}
              >
                Number of Tasks: {selectedTasks ? selectedTasks.length : 0} |
                Total Assets:{" "}
                {selectedTasks
                  ? selectedTasks.reduce(
                      (partialSum, { assets }) => +partialSum + +assets.length,
                      0
                    )
                  : 0}{" "}
                | learner Selected:{" "}
                {selectedLearners ? selectedLearners.length : 0} | Estimated
                Time:{" "}
                {selectedTasks
                  ? convertSecondToMin(
                      selectedTasks.reduce(
                        (partialSum, { estimated_time }) =>
                          +partialSum + +estimated_time,
                        0
                      )
                    )
                  : "0"}{" "}
                Mins
              </Typography>
            </Box>
          </Grid>
          <Confirmation
            visible={alertFlag}
            primaryText={currentMessage}
            image="error"
            alert={true}
            toggleModal={(flag) => setAlertFlag(flag)}
            timeout={3000}
          ></Confirmation>

          <Confirmation
            image="error"
            primaryText="You can not remove already assigned Learners"
            visible={errorModal}
            toggleModal={(flag) => setErrorModal(flag)}
            alert={true}
            timeout={3000}
          ></Confirmation>
          <Confirmation
            image="assign"
            primaryText="Assignment has been Assigned"
            secondaryText={`Assigned to ${selectedLearners.length} Learners`}
            visible={confirmModal}
            toggleModal={(flag) => setConfirmModal(flag)}
            alert={true}
            persistent={true}
            timeout={2500}
            onClose={() => {
              navigation("/Assign");
            }}
          ></Confirmation>
        </Grid>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default AssignCreateEdit;
